import { ManageAssetWithLicense } from "../../../../common/api/decimal/common-types/manageAssets.ts";

export type SearchSection = "favorite" | "recent" | "all";

export interface SearchCardProps {
  searchResult: {
    count: number;
    asset: ManageAssetWithLicense;
  };
  openPanel: (asset: ManageAssetWithLicense, section: SearchSection) => void;
  dynamicStyles?: React.CSSProperties;
  libraryReturn: string;
  section: SearchSection;
}

export const makeSearchReturnDetail = (section: string, vbid: string) =>
  `${section}-${vbid}`;
